var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2187134-FB1B-45F1-B38D-F500D6C6CA8F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion_change-emotion",
    transform: "translate(-125.000000, -727.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "negative-emotion-copy",
    transform: "translate(0.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sick-face",
    transform: "translate(92.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sick",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71572875,0 0,6.71572875 0,15 C0,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9906315,6.71961243 23.2803876,0.00936852177 15,0 Z",
    id: "Path",
    fill: "#76A197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.168,13.555 C8.02077176,13.3343498 7.96724276,13.0642442 8.01919232,12.8041213 C8.07114188,12.5439984 8.22431313,12.3151733 8.445,12.168 L10.2,11 L8.445,9.832 C8.14775503,9.6337176 7.97887175,9.2919188 8.00196686,8.9353559 C8.02506198,8.578793 8.23662678,8.2616364 8.55696686,8.1033559 C8.87730695,7.94507541 9.25775503,7.9697176 9.555,8.168 L12.555,10.168 C12.8331551,10.3534732 13.0002244,10.6656789 13.0002244,11 C13.0002244,11.3343211 12.8331551,11.6465268 12.555,11.832 L9.555,13.832 C9.33434979,13.9792282 9.06424421,14.0327572 8.80412132,13.9808077 C8.54399843,13.9288581 8.3151733,13.7756869 8.168,13.555 L8.168,13.555 Z",
    id: "Path",
    fill: "#EDFFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.041,22.662 C20.8654807,22.8610004 20.6180666,22.9820835 20.353235,22.9985886 C20.0884034,23.0150937 19.8278697,22.9256673 19.629,22.75 C16.9835869,20.4179185 13.0164131,20.4179185 10.371,22.75 C9.95678644,23.1156125 9.3246125,23.0762136 8.959,22.662 C8.5933875,22.2477864 8.63278644,21.6156125 9.047,21.25 C12.4486992,18.24993 17.5513008,18.24993 20.953,21.25 C21.1520004,21.4255193 21.2730835,21.6729334 21.2895886,21.937765 C21.3060937,22.2025966 21.2166673,22.4631303 21.041,22.662 L21.041,22.662 Z",
    id: "Path",
    fill: "#EDFFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.555,12.168 C22.0145009,12.474518 22.138518,13.0954991 21.832,13.555 C21.5254819,14.0145009 20.9045009,14.138518 20.445,13.832 L17.445,11.832 C17.1668449,11.6465268 16.9997756,11.3343211 16.9997756,11 C16.9997756,10.6656789 17.1668449,10.3534732 17.445,10.168 L20.445,8.168 C20.9045009,7.86148196 21.525482,7.98549909 21.832,8.445 C22.138518,8.90450091 22.0145009,9.52548196 21.555,9.832 L19.8,11 L21.555,12.168 Z",
    id: "Path",
    fill: "#EDFFFB"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSick);
export default __webpack_public_path__ + "static/media/sick.47d54374c854571c1d5b2dd970828697.svg";
export { ForwardRef as ReactComponent };